const LAYOUT_CONST = {
    VERTICAL_LAYOUT: 'vertical',
    HORIZONTAL_LAYOUT: 'horizontal',
    DEFAULT_DRAWER: 'default',
    MINI_DRAWER: 'mini-drawer'
};

export default LAYOUT_CONST;

export const TABLE_CONST = {
    DEFAULT_PER_PAGE: 20,
    DEFAULT_EXPORT_DATA: [
        { col: 'learnerId', title: 'Candidate ID' },
        { col: 'name.first', title: 'First Name' },
        { col: 'name.last', title: 'Last Name' },
        { col: 'email', title: 'Email' },
        { col: 'completeTime', title: 'Complete Time' }
    ],
    DATE_RANGE: [
        { range: -1, type: 'month', title: 'Last Month' },
        { range: -3, type: 'month', title: 'Last 3 Months' },
        { range: -12, type: 'month', title: 'Last 12 Months' }
    ]
};
